import React from 'react'
import { useTranslation } from 'react-i18next'

import { tableHeadersConfig } from '../../../../config/tableHeadersConfig'

import { StyledTableHeader, StyledHeaderCell, StyledRow } from './style'

export const TableHead = () => {
  const { t } = useTranslation()
  return (
    <StyledTableHeader>
      <StyledRow>
        {tableHeadersConfig.map(header => (
          <StyledHeaderCell key={header.value}>
            {t(`${header.title.toUpperCase()}`)}
          </StyledHeaderCell>
        ))}
      </StyledRow>
    </StyledTableHeader>
  )
}
